export default {
  baseStyle: {
    px: 0,
  },
}
